<script>
/* Import TinyMCE */
import tinymce from 'tinymce';

/* Default icons are required. After that, import custom icons if applicable */
import 'tinymce/icons/default';

/* Required TinyMCE components */
import 'tinymce/themes/silver';
import 'tinymce/models/dom';

/* Import a skin (can be a custom skin instead of the default) */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

/* content UI CSS is required */
import contentUiSkinCss from 'tinymce/skins/ui/oxide/content.css';

/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
import contentCss from 'tinymce/skins/content/default/content.css';

export default {
    data() {
        return {
            editorId: null,
        }
    },
    props: {
        value: {
            type: String,
            default(rawProp) {
                return rawProp && rawProp.value ? rawProp.value : '';
            },
            required: false,
        },
        cols: {
            type: Number,
            default(rawProp) {
                return rawProp && rawProp.cols ? rawProp.cols : 30;
            },
            required: false,
        },
        rows: {
            type: Number,
            default(rawProp) {
                return rawProp && rawProp.rows ? rawProp.rows : 10;
            },
            required: false,
        },
        cssClasses: {
            type: [Array, String],
            default(rawProp) {
                return rawProp && rawProp.cssClasses ? rawProp.cssClasses : null;
            },
            required: false,
        },
    },
    watch: {
        value: function () {
            this.setContent();
        }
    },
    async mounted() {
        await this.init();
        this.setContent();
    },
    methods: {
        randomString(len, an) {
            an = an && an.toLowerCase();
            var str = "",
                i = 0,
                min = an == "a" ? 10 : 0,
                max = an == "n" ? 10 : 62;
            for (; i++ < len;) {
                var r = Math.random() * (max - min) + min << 0;
                str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
            }
            return str;
        },
        async maybeDestroyEditor() {
            let component = this;
            if (component.editorId) {
                let editor = tinymce.get(component.editorId);
                if (editor) {
                    editor.destroy();
                }
            }
        },
        async initializeId() {
            let component = this;
            component.editorId = component.randomString(10, 'a');
        },
        async init() {
            let component = this;
            await component.initializeId()
            await tinymce.init({
                selector: `textarea#${component.editorId}`,
                plugins: 'advlist code emoticons link lists table',
                toolbar: 'bold italic | bullist numlist | link emoticons | forecolor backcolor',
                skin: false,
                font_family_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Calibri=Calibri,sans-serif; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                content_css: false,
                content_style: contentUiSkinCss.toString() + '\n' + contentCss.toString(),
                setup: (editor) => {
                    editor.on('Change', () => { component.emitValue(editor.getContent()) });
                    editor.on('keydown', () => { component.emitValue(editor.getContent()) });
                    editor.on('keyup', () => { component.emitValue(editor.getContent()) });
                }
            });
        },
        setContent() {
            let component = this;
            let editor = tinymce.get(component.editorId);
            if (editor) {
                let bookmark = editor.selection.getBookmark(2, true);
                editor.setContent(component.value, { format: 'html' });
                editor.selection.moveToBookmark(bookmark);
            }
        },
        emitValue(currentContent = '') {
            let component = this;
            if (currentContent) {
                component.$emit('input', currentContent);
            }
        }
    },
    computed: {
        computedClasses() {
            let elementClasses = ['rich-text-editor'];
            let component = this;
            if (component.cssClasses) {
                if (typeof component.cssClasses === 'string') {
                    elementClasses.push(component.cssClasses);
                } else if (Array.isArray(component.cssClasses)) {
                    elementClasses.push(...component.cssClasses);
                }
            }
            return elementClasses;
        }
    }
}
</script>
<template>
    <textarea :id="editorId" :class="computedClasses" :cols="cols" :rows="rows"></textarea>
</template>
<style>
body {
    margin: 0;
}
</style>